export var useFindEntities = function (entityId) {
    var findEntities = function (contentBlock, callback, contentState) {
        contentBlock.findEntityRanges(function (character) {
            var entityKey = character.getEntity();
            return (entityKey !== null &&
                contentState.getEntity(entityKey).getType() === entityId);
        }, callback);
    };
    return { findEntities: findEntities };
};
